import { type CustomDiscount } from './types';
import { ServiceDiscountTypes } from '@clients/AuthApi';

export const customDataDefault: CustomDiscount = {
    [ServiceDiscountTypes.Bus]: 0,
    [ServiceDiscountTypes.Flight]: 0,
    [ServiceDiscountTypes.Hotel]: 0,
    [ServiceDiscountTypes.InternationalFlight]: 0,
    [ServiceDiscountTypes.SuggestedService]: 0,
    [ServiceDiscountTypes.Train]: 0,
    [ServiceDiscountTypes.Taxi]: 0,
    [ServiceDiscountTypes.Bundle]: 0,
};
